import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import type { ControllerFieldState } from 'react-hook-form';
import { Info } from '@/components/icons/Info';
import { FormLabel } from '@/components/ui/form';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/styles';
type Props = {
  readonly label?: React.ReactNode;
  readonly fieldState?: ControllerFieldState;
  readonly required?: boolean;
  readonly className?: string;
  readonly tooltipContent?: React.ReactNode;
};
export function AppFormLabel(t0) {
  const $ = _c(9);
  const {
    label,
    required,
    className,
    tooltipContent
  } = t0;
  if (label == null) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex gap-1 mb-2 font-bold", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== required || $[3] !== tooltipContent) {
    t2 = required && <TooltipProvider><Tooltip><TooltipTrigger><span className="text-neutral-light-600"><Info /></span></TooltipTrigger><TooltipContent><p>{tooltipContent}</p></TooltipContent></Tooltip></TooltipProvider>;
    $[2] = required;
    $[3] = tooltipContent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== label || $[6] !== t1 || $[7] !== t2) {
    t3 = <FormLabel className={t1}>{label}{t2}</FormLabel>;
    $[5] = label;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}